<template>

  <el-row style="width: 100%;height: 100%">
    <el-col :span="12">
      <FrameQuery ref="frameQuery"  component-param="sys_msg_send" @current-change="rowChange"></FrameQuery>
    </el-col>

    <el-col :span="12" style="border: solid 1px #e5e5e5">
      <div class="detail-show" v-if="msg.title||msg.content">
        <el-form label-width="110px">

          <el-form-item >
            <el-button type="success" @click="forwardDialog=true" >转发</el-button>
            <el-button type="warning" @click="deleteDialog=true">删除</el-button>
          </el-form-item>

          <el-dialog title="转发" v-model="forwardDialog" :close-on-click-modal="false" width="500px">
            <el-form v-model="msg" label-width="80px">
              <el-form-item label="收件人：" required >
                <el-cascader v-model="msg.target_id" :options="departmentAndUserList" style="width: 100%"
                             :show-all-levels="false" placeholder="请选择" :props="props" clearable filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="抄送：">
                <el-cascader v-model="msg.copy_id" :options="departmentAndUserList" style="width: 100%"
                             :show-all-levels="false" placeholder="请选择" :props="props" clearable filterable>
                </el-cascader>
              </el-form-item>
            </el-form>
            <template #footer class="dialog-footer">
              <el-button @click="handleClose">取消</el-button>
              <el-button type="primary" @click="setForward">确定</el-button>
            </template>
          </el-dialog>

          <el-dialog title="删除" v-model="deleteDialog" :close-on-click-modal="false" width="500px" >
            <span style="font-size:20px">确定要删除{{msg.title}}</span>
            <template #footer class="dialog-footer">
              <el-button @click="deleteDialog=false">取消</el-button>
              <el-button type="primary" @click="deleteMsgSend(msg.id)">确定</el-button>
            </template>
          </el-dialog>

          <el-form-item label="发送时间">
            <el-input type="input" :readonly="true" v-model="msg.create_time"></el-input>
          </el-form-item>
          <el-form-item label="已读收件人" v-if="msg.read_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.read_user_names"></el-input>
          </el-form-item>
          <el-form-item label="未读收件人" v-if="msg.unread_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.unread_user_names"></el-input>
          </el-form-item>
          <el-form-item label="抄送" v-if="msg.copy_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.copy_user_names"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input type="input" :readonly="true" v-model="msg.title"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <KfCkEditor type="textarea" :readonly="true" :rows="15" v-model="msg.content"></KfCkEditor>
          </el-form-item>
          <el-form-item label="附件" v-if="msg.appendix_objects && msg.appendix_objects.length > 0">
            <div class="doc-list">
              <div v-for="appendix in msg.appendix_objects" :key="appendix.id">
                <a :href="appendix.url">{{ appendix.originalName}}</a>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>

export default {
  name: "MsgSend",
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        checkStrictly: false,
        multiple:true,
        emitPath:false
      },
      msg: {
        target_id:"",
        copy_id:"",
      },
      forwardDialog: false,
      deleteDialog: false,
      departmentAndUserList:[],

    }
  },
  methods: {

    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()
    },

    // 获取发消息详情
    clearPreData() {
      this.msg = []
      this.departmentAndUserList = []
    },
    async rowChange(currentRow) {
      let msgId = currentRow?.id
      if (!msgId) {
        return;
      }
      let params = {id : msgId}
      let data = await this.$http('msgService.getMsgDetail', params)
      this.msg = data || {};
      this.getDepartmentAndUser()
    },

    //获取收件人
    async getDepartmentAndUser(){
      this.departmentAndUserList = await this.$http('sysUserDepartmentService.getDepartmentAndUser')
    },

    //转发消息
    async setForward(){
      await this.$http('msgService.create', this.msg)
      this.$message.success("转发成功")
      this.handleClose()
      this.$refs.frameQuery.search();
      this.clearPreData()
    },
    handleClose() {
      this.forwardDialog = false;
      this.msg.target_id = ''
      this.msg.copy_id = ''
    },
    //删消息
    async deleteMsgSend(id) {
      if (!id) {
        return;
      }
      let params = {id : id}
      await this.$http('msgService.deleteMsgSend', params)
      this.$message.success("删除成功")
      this.$refs.frameQuery.search();
      this.clearPreData()
    },

    downloadFile(appendix) {
      let url = appendix?.active_ver?.sys_file?.url;
      if (!url) {
        return
      }
      let name = appendix.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    viewFile() {
      this.$store.dispatch('core/openWindow', {
        component: 'oa/ViewPdf',
        name: '文件查看',
        max: true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-show {
  padding: 15px 30px 5px 5px;
  min-height: 450px;
  word-break: break-all;
}

.doc-list {
  width: 100%;
  min-height: 100px;
}

</style>